import { ServiceCostGeneral } from '@contler/models/room-service';

export interface HotelConfigModel {
  timeToSendNotAttendedNotification: number;
  backgroundColor?: string;
  headerColor?: string;
  modules: Modules;
  fiveStarsModal: FiveStarsModal;
  preStayFeatures: Feature[];
  selectedUiTemplate: number;
  serviceCost: ServiceCost;
  passwordGuest: string;
  enableNewHome: boolean;
  baseLanguage: BaseLanguage;
  currency: Currency;
  contactURL: ContactURL;
  promotionSidebar: PromotionSidebar;
  notificationTokens: string[];
  features: Feature[];
  openAnonymousOnWelcome: boolean;
  redirectNewHome: boolean;
  whiteLabel?: boolean;
  customFontUrl?: string | null;
  customFontName?: string | null;
  paymentsConfig: PaymentsConfig;
  notificationsConfig?: NotificationsConfiguration;
  establishmentType?: string;
}

export interface PaymentsConfig {
  enable: boolean;
  paymentsMethods: PaymentMethod[];
  accumulate: boolean;
  paymentGateway?: string | null;
  mpCredential?: {
    publicKey: string;
    privateKey: string;
    value: string;
  } | null;
  credentials?: Record<string, string> | null;
}

export enum PaymentMethod {
  CASH = 'typeOfPayment.cash',
  DIGITAL = 'typeOfPayment.creditCard',
  ROOM_CHARGE = 'typeOfPayment.chargeToTheRoom',
  HOTEL = 'hotel',
}

export interface BaseLanguage {
  englishName: string;
  unicode: string;
  code: string;
  name: string;
  prefix: string;
}

export interface ContactURL {
  url: string;
  status: boolean;
  icon: string;
}

export interface Currency {
  status: boolean;
  symbol: string;
  decimal: string;
  alphabetCode: string;
  locale: string;
  numberCode: string;
}

export interface Feature {
  key: string;
  name: string;
  enabled: boolean;
}

export interface FiveStarsModal {
  link: string;
  title: string;
  status: boolean;
  button: string;
  description: string;
}

export interface Modules {
  free: number;
}

export interface PromotionSidebar {
  name: string;
}

export interface ServiceCost {
  roomService: ServiceCostGeneral;
}

export interface NotificationsConfiguration {
  allowedInAllServices: boolean;

  requestsNotifications: ServiceNotificationConfiguration;
  roomServiceNotifications: ServiceNotificationConfiguration;
  reservationsNotifications: ServiceNotificationConfiguration;
  allServicesNotifications: ServiceNotificationConfiguration;
}

export interface ServiceNotificationConfiguration {
  enabledServices: string[];
  notificationTone: string;
  notificationText: string;
  notificationFrequencyInMinutes: number;
}
